import { all, takeEvery, select, call, put } from "@redux-saga/core/effects";
import actionTypes from "../actions/actionTypes";
import { httpClient, billingInformationBaseUrl } from "../../http-client/http-client";
import { billingInfoActions } from '../actions/billingInformation/billingInformation';

const accessTokenSelector = (state) => state.oidc.user.access_token;
const languageSelector = state => state.settings.language;

function* fetch(action) {
  const accessToken = yield select(accessTokenSelector);
  const language = yield select(languageSelector);
  const url = `${billingInformationBaseUrl}?lang=${language}`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(billingInfoActions.fetchOk(data));
  }
  catch(error){
    yield put(billingInfoActions.fetchError(error));
  }
}

export function* watchBillingInformation() {
  yield all([
    takeEvery(actionTypes.billingInformation.FETCH, fetch),
  ]);
}